<pdf-document-viewer></pdf-document-viewer>
<div class="close-button" (click)="closeViewer()"> <icon-cross></icon-cross></div>